/**
 * Tries to parse JSON in more forgiving way than regular parse
 */
export function fixJsonString(data: string): string | undefined {
    try {
        return JSON.stringify(JSON.parse(data));
    } catch (e) {
        // console.log(e);
        try {
            // tslint:disable:no-eval
            const ob = eval('(' + data + ')');

            // tslint:enable:no-eval
            if (typeof ob === 'object') {
                return JSON.stringify(ob);
            }
        } catch (e) {
            // console.log(e);
        }
    }
    return undefined;
}
